import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import { useStores } from '../../stores';
import axios from 'axios';
import DataBarNotActive from '../../../public/Images/DataBarNotActive.svg';
import DataBarActive from '../../../public/Images/DataBarActive.svg';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { BasicTable } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import specificDeductibleCorridorsMessages from '../../core-utils/messages/specificDeductibleCorridorsMessages';
import { pageScrollDown } from '../SummaryPage';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import snackbarMessages from '../../core-utils/messages';
import properties from '../../core-utils/properties';
import {
  PageTitleAndSubTitle,
  SwitchWithAndOrInput,
  VerticalBar,
  TextWithColorDotAndDottedText,
  NoDataTable,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import EmptyData from '../../_components/atoms/Icons/EmptyData';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import {
  Columns,
  cellStyles3,
  cellStyles4,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { numberToCurrencyFormatter } from '../../core-utils/helper-utils/helper';
import { CircularLoader } from '@HomaHealth/ui-component-library';

const SpecificDeductibleCorridors = () => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 63px',
    },
    elements: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingTop: '40px',
    },
    deductibles: {
      display: 'flex',
      flexDirection: 'column',
    },
    middleBar: {},
    activeBar: {
      width: '270px',
      height: '500px',
      position: 'relative',
    },
    barChart: {
      position: 'absolute',
      top: '27.8%',
      left: '33.8%',
      zIndex: 2,
      width: '64px',
      height: '265px',
      display: 'flex',
      flexDirection: 'column',
    },
    image: {
      position: 'absolute',
      top: '0',
      left: '0',
      zIndex: 1,
    },
    tables: {
      display: 'flex',
      flexDirection: 'column',
      gap: '22px',
      marginTop: '6px',
    },
    emptyData: {
      margin: '100px 100px 0px 0px',
    },
  });

  const { classes } = useStyles();
  const messages =
    specificDeductibleCorridorsMessages.SPECIFIC_DEDUCTIBLE_CORRIDORS_PAGE;

  const employerGroupStore = useStores().employerGroupStore;

  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);

  //snacker bar variables and functions
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = () => {
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const setIsOn = (index: number) => {
    const updatedSwitchComponents = [...switchComponents];
    updatedSwitchComponents[index].isOn = !updatedSwitchComponents[index].isOn;
    setSwitchComponents(updatedSwitchComponents);
  };

  //for and or
  const handleAndOrChange = (
    deductibleIndex: number,
    index: number,
    toggleValue?: 'left' | 'right',
  ) => {
    const updatedSwitchComponents = [...switchComponents];
    if (
      !updatedSwitchComponents?.[deductibleIndex]?.valuesState?.[index]
        ?.showAndOr
    ) {
      return;
    }
    updatedSwitchComponents[deductibleIndex].valuesState[
      index
    ].andOrState = toggleValue;
    setSwitchComponents(updatedSwitchComponents);
    setIsTableLoading(true);
    getDeductibleTables(deductibleIndex);
  };

  //for setting amount
  const setAmount = (deductibleIndex: number, index: number, value: string) => {
    const updatedSwitchComponents = [...switchComponents];
    updatedSwitchComponents[deductibleIndex].valuesState[index].amount = Number(
      value,
    );
    setSwitchComponents(updatedSwitchComponents);
    setIsTableLoading(true);
    getDeductibleTables(deductibleIndex);
  };

  //for handling switch inner
  const handleSwitch = (deductibleIndex: number, index: number) => {
    //showAndOr logic here
    const updatedSwitchComponents = [...switchComponents];
    updatedSwitchComponents[deductibleIndex].valuesState[
      index
    ].switchState = !updatedSwitchComponents[deductibleIndex].valuesState[index]
      .switchState;

    if (
      updatedSwitchComponents[deductibleIndex].valuesState[index].switchState
    ) {
      updatedSwitchComponents[deductibleIndex].valuesState[
        index
      ].amount = 10000;
    } else {
      updatedSwitchComponents[deductibleIndex].valuesState[index].amount = '';
    }

    if (
      index !==
        updatedSwitchComponents[deductibleIndex].valuesState.length - 1 &&
      updatedSwitchComponents[deductibleIndex].valuesState[index].switchState &&
      updatedSwitchComponents[deductibleIndex].valuesState[index + 1]
        .switchState
    ) {
      updatedSwitchComponents[deductibleIndex].valuesState[
        index
      ].showAndOr = true;
    }
    if (
      index !==
        updatedSwitchComponents[deductibleIndex].valuesState.length - 1 &&
      !updatedSwitchComponents[deductibleIndex].valuesState[index]
        .switchState &&
      updatedSwitchComponents[deductibleIndex].valuesState[index + 1]
        .switchState
    ) {
      updatedSwitchComponents[deductibleIndex].valuesState[
        index
      ].showAndOr = false;
    }

    if (
      index !== 0 &&
      updatedSwitchComponents[deductibleIndex].valuesState[index].switchState &&
      updatedSwitchComponents[deductibleIndex].valuesState[index - 1]
        .switchState
    ) {
      updatedSwitchComponents[deductibleIndex].valuesState[
        index - 1
      ].showAndOr = true;
    }
    if (
      index !== 0 &&
      !updatedSwitchComponents[deductibleIndex].valuesState[index]
        .switchState &&
      updatedSwitchComponents[deductibleIndex].valuesState[index - 1]
        .switchState
    ) {
      updatedSwitchComponents[deductibleIndex].valuesState[
        index - 1
      ].showAndOr = false;
    }

    setSwitchComponents(updatedSwitchComponents);
    setIsTableLoading(true);
    getDeductibleTables(deductibleIndex);
  };

  const [switchComponents, setSwitchComponents] = useState<any[]>([
    {
      deductibleName: 'Reinsurance/Stoploss',
      isOn: false,
      colorDot: '#E08083',
      setIsOn: setIsOn,
      handleAndOrChange: handleAndOrChange,
      valuesState: [
        {
          name: 'Aggregate Deductible',
          switchState: false,
          amountValues: Array.from(
            { length: (200000 - 10000) / 10000 + 1 },
            (_, index) => 10000 + index * 10000,
          ).map((num) => num.toString()),
          amount: '',
          setAmount: setAmount,
          showAndOr: false,
          andOrState: 'left',
          setSelectedToggle: () => {},
          handleSwitch: handleSwitch,
        },
        {
          name: 'Specific Deductible',
          switchState: false,
          amountValues: Array.from(
            { length: (200000 - 10000) / 10000 + 1 },
            (_, index) => 10000 + index * 10000,
          ).map((num) => num.toString()),
          amount: '',
          setAmount: setAmount,
          showAndOr: false, //Always false
          andOrState: 'left',
          setSelectedToggle: () => {},
          handleSwitch: handleSwitch,
        },
      ],
    },
  ]);

  const [tablesData, setTablesData] = useState<any[]>([
    {
      title: 'Reinsurance/Stoploss',
      colorDot: '#E08083',
      dottedText: 'View additional details',
    },
    {
      title: 'Captive',
      colorDot: '#08C7B4',
      dottedText: 'View additional details',
    },
    {
      title: 'Self Insured',
      colorDot: '#6C7DC0',
      dottedText: 'View additional details',
    },
  ]);

  const [verticalBarState, setVerticalBarState] = useState<any>({
    redValue: 0,
    greenValue: 0,
    blueValue: 0,
  });

  const prepareTableData = (index: number, data: any) => {
    const columns: Columns[] = [
      {
        name: 'Year',
        align: 'left',
        cellStyles: cellStyles4,
        width: '120px',
      },
    ];
    const rowsData = [['Members'], ['Cost']];
    const iconsData = [];

    for (const value of data) {
      columns.push({
        name: value.duration,
        align: 'left',
        cellStyles: { ...cellStyles3, fontWeight: 400 },
        width: '80px',
      });
      rowsData[0].push(value.members);
      rowsData[1].push(numberToCurrencyFormatter(value.totalCost, true, 2));
    }

    if (index === 2) {
      iconsData.push(messages.INFO_TEXTS[index].MEMBERS);
      iconsData.push(messages.INFO_TEXTS[index].COSTS);
    } else {
      iconsData.push(messages.INFO_TEXTS[index].MEMBERS);
      if (
        switchComponents?.[index]?.valuesState?.[0]?.showAndOr &&
        switchComponents?.[index]?.valuesState?.[0]?.andOrState === 'left'
      ) {
        iconsData.push(messages.INFO_TEXTS[index].COSTS_AGGR_AND_SPEC);
      } else if (
        switchComponents?.[index]?.valuesState?.[0]?.showAndOr &&
        switchComponents?.[index]?.valuesState?.[0]?.andOrState === 'right'
      ) {
        iconsData.push(messages.INFO_TEXTS[index].COSTS_AGGR_OR_SPEC);
      } else if (switchComponents?.[index]?.valuesState?.[0]?.switchState) {
        iconsData.push(messages.INFO_TEXTS[index].COSTS_ONLY_AGGR);
      } else {
        iconsData.push(messages.INFO_TEXTS[index].COSTS_ONLY_SPEC);
      }
    }

    const updatedTablesData = [...tablesData];
    return {
      ...updatedTablesData[index],
      columns: columns,
      rowsData: rowsData,
      iconsData: iconsData,
    };
  };

  const calculateTableData = (data: any) => {
    const updatedTablesData = [...tablesData];
    const verticalBar = {
      redValue: 0,
      greenValue: 0,
      blueValue: 0,
    };

    if (data?.reinsuranceTable && data.reinsuranceTable?.length > 0) {
      verticalBar.redValue = data.reinsuranceTable[0].totalCost;
      updatedTablesData[0] = prepareTableData(0, data.reinsuranceTable);
    } else {
      updatedTablesData[0]['columns'] = [];
    }
    if (data?.captiveTable && data.captiveTable?.length > 0) {
      verticalBar.greenValue = data.captiveTable[0].totalCost;
      updatedTablesData[1] = prepareTableData(1, data.captiveTable);
    } else {
      updatedTablesData[1]['columns'] = [];
    }
    if (data?.selfInsuredTable && data.selfInsuredTable?.length > 0) {
      verticalBar.blueValue = data.selfInsuredTable[0].totalCost;
      updatedTablesData[2] = prepareTableData(2, data.selfInsuredTable);
    } else {
      updatedTablesData[2]['columns'] = [];
    }

    setVerticalBarState(verticalBar);
    setTablesData(updatedTablesData);
  };

  const showTable = () => {
    for (let i = 0; i < switchComponents.length; i++) {
      if (switchComponents[i].isOn === true) {
        return true;
      }
    }
    return false;
  };

  const getDeductibleTables = async (index: number) => {
    await axios
      .post(properties.aiqBaseUrl + properties.specificDeductibles, {
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        end_year: employerGroupStore?.employerGroupResponseData?.end_year,
        plan_end_month:
          employerGroupStore?.employerGroupResponseData?.plan_end_month,
        plan_start_month:
          employerGroupStore?.employerGroupResponseData?.plan_start_month,
        start_year: employerGroupStore?.employerGroupResponseData?.start_year,
        aggregate_deductible_amount:
          switchComponents?.[index]?.valuesState?.[0]?.amount || null,
        and_or:
          switchComponents?.[index]?.valuesState?.[0]?.andOrState === 'left'
            ? 'and'
            : switchComponents?.[index]?.valuesState?.[0]?.andOrState ===
              'right'
            ? 'or'
            : '',
        specific_deductible_amount:
          switchComponents?.[index]?.valuesState?.[1]?.amount,
      })
      .then((response) => {
        const data = response?.data?.data;
        calculateTableData(data);
        setIsTableLoading(false);
      })
      .catch((error) => {
        handleOpenSnackBar(
          error.response?.data?.error ?? snackbarMessages.SOMETHING_WENT_WRONG,
          'error',
          8000,
        );
        setIsTableLoading(false);
      });
  };

  return (
    <>
      <Grid container className={classes.root}>
        <PageTitleAndSubTitle
          title={messages.TITLE}
          subTitle={messages.SUB_TITLE}
          customButton={true}
          customButtonText={messages.BUTTON_TEXT}
          customButtonClick={() => {}}
        />
        <Grid container className={classes.elements}>
          <Grid className={classes.deductibles}>
            {switchComponents.map((switchState, index1) => {
              return (
                <React.Fragment key={index1}>
                  <SwitchWithAndOrInput
                    deductibleName={switchState.deductibleName}
                    deductibleIndex={index1}
                    isOn={switchState.isOn}
                    setIsOn={switchState.setIsOn}
                    colorDot={switchState.colorDot}
                    valuesState={switchState.valuesState}
                    handleAndOrChange={switchState.handleAndOrChange}
                  />
                </React.Fragment>
              );
            })}
          </Grid>

          <Grid className={classes.middleBar}>
            {showTable() ? (
              <Grid container className={classes.activeBar}>
                <img
                  src={DataBarActive}
                  alt="DataBarActive"
                  className={classes.image}
                />
                <VerticalBar
                  styles={{
                    position: 'absolute',
                    top: '27.8%',
                    left: '33.8%',
                    zIndex: 2,
                    width: '64px',
                    height: '265px',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                  color1Value={verticalBarState.redValue}
                  color2Value={verticalBarState.greenValue}
                  color3Value={verticalBarState.blueValue}
                  color1={'#E080838F'}
                  color2={'#08C7B48F'}
                  color3={'#6C7DC08F'}
                />
              </Grid>
            ) : (
              <img
                style={{ margin: '60px 0px 0px 0px' }}
                src={DataBarNotActive}
                alt="DataBarNotActive"
              />
            )}
          </Grid>

          <Grid>
            {showTable() ? (
              <Grid className={classes.tables}>
                {isTableLoading ? (
                  <CircularLoader />
                ) : (
                  tablesData.map((data, index: number) => {
                    return (
                      <div key={index}>
                        <TextWithColorDotAndDottedText
                          title={data.title}
                          colorDot={data.colorDot}
                          // dottedText={data.dottedText}
                          dottedTextAction={() => {}}
                        />
                        {data?.columns?.length > 0 ? (
                          <BasicTable
                            width="450px"
                            displayType="row"
                            columns={data.columns}
                            rowsData={data.rowsData}
                            isItagTable={true}
                            iconsData={data.iconsData}
                            headerCellHeight="34px"
                            cellHeight="38px"
                          />
                        ) : (
                          <NoDataTable
                            height="128px"
                            width="450px"
                            content="No Data For This Table"
                          />
                        )}
                      </div>
                    );
                  })
                )}
              </Grid>
            ) : (
              <Grid
                container
                className={classes.emptyData}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <Grid>
                  <EmptyData />
                </Grid>
                <Grid>
                  <Typography
                    fontSize="14px"
                    fontType="regular"
                    lineHeight="24.78px"
                    textColor={patientAccessTheme.palette.text.mediumemphasis}
                  >
                    {messages.EMPTY_TEXT}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        <div id="scroll-top-element"></div>
        {pageScrollDown('scroll-top-element')}
      </Grid>
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
};
export default SpecificDeductibleCorridors;
